import React, { useState } from 'react';
import EasyRecceVideo from '../../assest/videos/EasyRecceVideo.mp4';
import { Link } from 'react-router-dom';
import { GoChevronDown } from "react-icons/go";
import Search from '../Search/Search';
import ButtonStyle from "../Styles/Button.module.css";
import { LuSearch } from "react-icons/lu";
import CommonStyle from '../Styles/Common.module.css';
import FontStyle from '../Styles/FontStyle.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col'; 
import ClientRequest from '../Browse/ClientRequest';
const Index = ({ easyrecceRef }) => {
    const [openForm, setOpenForm] = useState(false)
    const locationReqHandel=()=>{
        setOpenForm(true)
    }
    const [searchBox, setSearchBox ] = useState(false);
    const showSearchHandler = ()=>{
        setSearchBox(true)
    }
    const closeSearchHandler = ()=>{
        setSearchBox(false)
    }
    // ✅ Scroll function to Easyrecce
    const handleScroll = () => {
        easyrecceRef.current?.scrollIntoView({ behavior: "smooth" });
    };
    const handleCallback = (data) => {};
    return (
        <div className="indexStyle">
            <div className="indexvideo">
                <video src={EasyRecceVideo} loop muted autoPlay className="backgroundVideo"></video>
            </div>
            <div className="indexContent">
                <p className='clientBtn'><button type='button' onClick={locationReqHandel}>Click Here</button> to submit your filming location requirements</p>
                {/* <p>
                    EasyRecce is an appointment-only service,{' '}
                    <Link to="mailto:juhi@easyrecce.com,lalit@easyrecce.com?body=Dear Team EasyRecce,%0AI am keen to learn more about EasyRecce.%0ACould we schedule an call at a convenient time%3f%0ALooking forward to exploring how Easy Recce can support our production needs.%0ABest regards,">click here</Link> to contact us
                </p> */}
               

                <div className={CommonStyle.SearchFilter + " " + CommonStyle.noSpace}>
                    <Container>
                        <Row>
                            <Col>
                            <div className={CommonStyle.responsiveView + ' ' + CommonStyle.tabSearch}>
                                <button type="button" onClick={showSearchHandler} className={ ButtonStyle.defaultButton + " " + CommonStyle.tabSearchButton}>
                                    Search Now <LuSearch className={ButtonStyle.buttonArrow} />
                                </button>
                            </div>
                            {searchBox && 
                                <div className={CommonStyle.searchOverLay}>
                                <div className={CommonStyle.tabSerachContainer}>
                                    <button type='button' onClick={closeSearchHandler} className={CommonStyle.closeSearch}><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M25.1111 10.8889L10.8889 25.1111M10.8889 10.8889L25.1111 25.1111M34 18C34 26.8366 26.8366 34 18 34C9.16345 34 2 26.8366 2 18C2 9.16345 9.16345 2 18 2C26.8366 2 34 9.16345 34 18Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                                    <Search parentCallback={handleCallback} />
                                </div>
                                </div> 
                            }
                            <div className={CommonStyle.searchBrownBg + ' ' + CommonStyle.desktopView}>
                                <Search parentCallback={handleCallback} />
                            </div>
                            </Col>
                        </Row>
                        </Container>
                </div>
                <button type="button" onClick={handleScroll} className="scrollDown">
                    <GoChevronDown  />
                </button>
            </div>
            {openForm &&
                <ClientRequest onClose={() => setOpenForm(false)} />
            }
        </div>
    );
};

export default Index;
